<template>
    <div class="bottom">
        <div class="companyMessage">
            <div class="system_message">
                <div class="system_name">
                    <img src="../../assets/images/bottom_logo.png" alt="">
                    <!-- 美溪｜AI智能系统 -->
                </div>
                <div class="system_desc">
                    云阙AI隶属于上海云阙智能科技有限公司，公司致力于为品牌企业提供内容营销领域的一站式解决方案。公司利用自身在软件开发及 AIGC 内容生成的核心技术优势，致力于推动 AIGC
                    内容营销管理流程在中国营销领域的应用和普及，面向品牌公司提供咨询服务，产品服务，开放平台等一系列服务内容。我们将采用更前沿的技术路线及运营模式，努力将云阙AI打造为国内一流的 AIGC
                    内容营销软件产品，并不断将AIGC的技术能力应用到各行各业，为中国发展为科技强国添砖加瓦。
                </div>
                <div class="contact_us">
                    <div style="font-size: 18rem;">联系我们</div>
                    <div class="ways">
                        <div class="contact_way">
                            <div style="display: flex;align-items: center;">
                                <div class="way_icon"><img src="../../assets/images/cpyjfk.png" alt="" srcset=""></div>
                                <div>
                                    <div>产品意见反馈</div>
                                    <div style="margin-top: 8rem;">zoe.li@yunquetech.info</div>
                                </div>
                            </div>

                        </div>
                        <div class="contact_way">
                            <div style="display: flex;align-items: center;">
                                <div class="way_icon"><img src="../../assets/images/swhz.png" alt="" srcset=""></div>
                                <div>
                                    <div>商务合作联系</div>
                                    <div style="margin-top: 8rem;">lizzy.zhao@yunquetech.info</div>
                                </div>
                            </div>
                        </div>
                        <div class="contact_way">
                            <div style="display: flex;align-items: center;">
                                <div class="way_icon"><img src="../../assets/images/gzsj.png" alt="" srcset=""></div>
                                <div>
                                    <div>工作时间</div>
                                    <div style="margin-top: 8rem;">工作日 9:30 - 18:30</div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
            <!-- <div class="contact_code">
                <div>
                    <div class="code_name">
                        <div class="border-left"></div>
                        <span>美溪</span>
                    </div>
                    <div class="code">
                        <img src="../../assets/images/link.png" alt="">
                    </div>
                    <div class="code_type">
                        微信公众号
                    </div>
                </div>
                <div style="margin-left: 80rem;">
                    <div class="code_name">
                        <div class="border-left"></div>
                        <span>美溪客服</span>
                    </div>
                    <div class="code">
                        <img src="../../assets/images/link.png" alt="">
                    </div>
                    <div class="code_type">
                        微信客服
                    </div>
                </div>
            </div> -->
        </div>
        <div class="name">
            Copyright © 2022- {{ year }} All Rights Reserved 上海云阙智能科技有限公司版权所有 沪ICP备2022029504号-1
        </div>
    </div>
</template>
<script>
export default {
    name: 'headPage',
    computed: {
        year() {
            return new Date().getFullYear()
        }
    }
}
</script>
<style lang="less" scoped>
img {
    width: 100%;
    height: 100%;
}

.bottom {
    width: 100%;

    .companyMessage {
        width: 100%;
        // height: 450rem;
        display: flex;
        background: linear-gradient(180deg, #F6F7FF 0%, rgba(234, 235, 255, 0) 100%);
        justify-content: space-between;
        // padding-bottom: 25rem;   
        height: 415rem;
        background: url(../../assets/images/bottom_bg.png);
        background-size: 100% 100%;

        .system_message {
            color: #2A32A5;

            width: 1408rem;
            // margin-top: 78rem;
            margin: 50rem auto;
            text-align: center;

            // width: 950rem;
            .system_name {
                // font-size: 50rem;
                // display: flex;
                // align-items: center;
                // justify-content: center;
                width: 375rem;
                height: 50rem;
                margin: 0 auto;
                font-weight: 500;
            }

            .system_desc {
                font-size: 18rem;
                margin-top: 24rem;
                text-align: left;
                // padding-right: 175rem;
            }

            .contact_us {
                margin-top: 45rem;
                font-size: 14rem;
                text-align: center;

                .ways {
                    display: flex;
                    justify-content: space-around;
                    margin-top: 24rem;
                    // margin: 15rem auto;

                    .contact_way {
                        // margin-top: 16rem;
                        font-size: 14rem;
                        text-align: left;

                        .way_icon {
                            width: 50rem;
                            height: 50rem;
                            margin-right: 14rem;
                        }
                    }
                }

            }
        }

        .contact_code {
            margin-right: 242rem;
            margin-top: 132rem;
            display: flex;

            .code_name {
                display: flex;
                align-items: center;
                font-size: 30rem;
                color: #2A32A5;


                .border-left {
                    width: 8rem;
                    height: 30rem;
                    background: linear-gradient(135deg, #99F1EF 0%, #505BFF 100%);
                    display: inline-block;
                    margin-right: 8rem;
                }
            }

            .code {
                width: 180rem;
                height: 180rem;
                margin-top: 16rem;
            }

            .code_type {
                width: 180rem;
                margin-top: 16rem;
                text-align: center;
                color: #505BFF;
                font-weight: bold;
            }

        }
    }

    .name {
        width: 100%;
        height: 40rem;
        text-align: center;
        line-height: 40rem;
        background: rgba(42, 50, 165, 1);
        color: #FFFFFF;
        font-size: 14rem;
    }
}
</style>